import { LOGIN_MODAL_SHOW } from '../constants';

const defaultState = {
  open: false,
  registerUserLink: '',
};

export const login = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_MODAL_SHOW:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
